import type { ConnectionKind } from '../../../../types/network';

/**
 * SVG symbols of the live map's house markers (NetworkMarker) and the map
 * legend. One source, so the legend draws exactly what the map shows.
 * Paths are for a 24×24 stroke icon.
 */
export const CONNECTION_KIND_SVG: Record<ConnectionKind, string> = {
  household: '<path d="m3 10 9-7 9 7v11h-6v-7H9v7H3z"/>',
  mixed: '<path d="m2 10 7-6 7 6v11H2zM16 9h6v12h-6M6 15h3m9-2h1m-1 4h1"/>',
  commercial: '<path d="M3 21V5h18v16M1 21h22M7 9h2m6 0h2M7 13h2m6 0h2M10 21v-4h4v4"/>',
  rlm: '<path d="M3 21V10l6 3V7l6 3V3h6v18zM7 17h2m4 0h2m2 0h2"/>',
  connection_pillar: '<rect x="6" y="2" width="12" height="20" rx="2"/><path d="m13 6-4 6h6l-4 6"/>',
  generation: '<circle cx="12" cy="12" r="4"/><path d="M12 1v3m0 16v3M1 12h3m16 0h3M4 4l2 2m12 12 2 2M4 20l2-2M18 6l2-2"/>',
};

export const SMGW_SVG = '<rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8 7h8v5H8zM9 17h.01M15 17h.01"/>';
export const STEUERBOX_SVG = '<rect x="4" y="4" width="16" height="16" rx="2"/><path d="M8 9h8M8 15h8M10 7v4m4 2v4"/>';
export const OTHER_DEVICE_SVG = '<circle cx="12" cy="12" r="8"/><path d="M8 12h8m-4-4v8"/>';

/** Technische Ressourcen in the dock's fixed order (DESIGN.md → Karte). */
export const RESOURCE_ORDER = ['pv_anlage', 'heat_pump', 'wallbox', 'battery_storage', 'air_conditioning', 'other'];

export const RESOURCE_SVG: Record<string, string> = {
  pv_anlage: '<path d="m5 5-3 12h20L19 5zM4 11h16M10 5l-1 12m5-12 1 12M12 17v4m-5 0h10"/>',
  battery_storage: '<rect x="3" y="6" width="17" height="12" rx="2"/><path d="M20 10h2v4h-2M7 12h6m-3-3v6"/>',
  heat_pump: '<rect x="2" y="4" width="20" height="16" rx="2"/><circle cx="10" cy="12" r="5"/><path d="m7 9 6 6m0-6-6 6M18 8v8"/>',
  wallbox: '<rect x="4" y="2" width="12" height="20" rx="2"/><path d="m11 6-3 5h5l-3 5M16 9h2a3 3 0 0 1 3 3v6a2 2 0 0 1-4 0v-3"/>',
  air_conditioning: '<rect x="2" y="3" width="20" height="11" rx="2"/><path d="M5 10h14M7 17v4m5-4v3m5-3v4"/>',
};

export const RESOURCE_SHORT: Record<string, string> = {
  pv_anlage: 'PV', battery_storage: 'Bat', heat_pump: 'WP',
  wallbox: 'WB', air_conditioning: 'Klima', other: 'Gerät',
};

/** Tint class suffix of `.ha-device-badge--<tone>` (map-performance.css). */
export const RESOURCE_TONE: Record<string, string> = {
  pv_anlage: 'solar', battery_storage: 'storage', heat_pump: 'thermal',
  wallbox: 'mobility', air_conditioning: 'climate', other: 'other',
};

/** German names for technische Ressourcen (tooltip line and badge titles). */
export const RESOURCE_TYPE_LABEL: Record<string, string> = {
  pv_anlage: 'PV-Anlage',
  battery_storage: 'Batteriespeicher',
  heat_pump: 'Wärmepumpe',
  wallbox: 'Wallbox',
  air_conditioning: 'Klimaanlage',
  other: 'Sonstige Einrichtung',
};

export const symbolSvg = (content: string, size = 20) =>
  `<svg aria-hidden="true" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">${content}</svg>`;
